module.exports = __webpack_public_path__ + "img/cut3icon.71f18a4c.png";